import { Stack } from '@mui/material'
import React from 'react'

interface MenuItemFieldProps {
  icon?: JSX.Element | undefined
  label: string
}

const MenuItemField = (props: MenuItemFieldProps) => {
  return (
    <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
      <Stack>{props.icon}</Stack>
      <Stack>{props.label}</Stack>
    </Stack>
  )
}
export default MenuItemField
